module.exports = __webpack_public_path__ + "cdc49661df94399dea2a081b95e503f8.svg";